import React from 'react';
import { useNavigate } from 'react-router-dom';
import bg2 from './assets/bg2.jpg';
import './styles/homeinfo.css';

const HomeInfo = () => {
  const navigate = useNavigate();
  const features = [
    { text: 'Comprehensive and cost-effective health technological solution.' },
    { text: 'Customer satisfaction through exceptional service and support.' },
    { text: 'Strong partnerships with national and international companies.' },
    { text: 'Wide range of services to meet diverse needs of our customers.' },
  ];

  return (
    <div className="home-section">
      <div className="section-container">
        <div className="content-wrapper">
          <h1 className="main-title">
            <span className="title-line">YORK Engineering:</span>
            <span className="title-line">Innovation at the Core</span>
          </h1>
          <p className="subtitle">
            Crafted for efficiency, designed for the future.
          </p>
          <div className="features-wrapper">
            {features.map((feature, index) => (
              <div key={index} className="feature-item">
                <span className="bullet-point">✔</span>
                <span className="home-text">{feature.text}</span>
              </div>
            ))}
          </div>
          <button onClick={() => navigate('/about')} className="cta-button">
            Learn more
          </button>
        </div>
        <div className="image-wrapper">
          <img src={bg2} alt="Medical Equipment" className="main-image" />
        </div>
      </div>
    </div>
  );
};

export default HomeInfo;